module.exports = __webpack_public_path__ + "img/icon107.aefe5ce6.jpeg";